class QnaContainer extends HTMLElement {
  constructor() {
    super();

    this.question = this.querySelector(".question");
    this.init();
  }

  init() {
    this.question.addEventListener("click", this.clickQuestion.bind(this));
  }

  clickQuestion(event) {
    const answer = this.querySelector(".answer");
    this.question.querySelector('svg') ?.classList.toggle('rotated');
    answer.classList.toggle("open");
  }
}

customElements.define("qna-container", QnaContainer);
